import 'ckeditor5/ckeditor5.css';

import enhanceEmbeddedContentHtml from '@/utils/enhanceEmbeddedContentHtml';

type Props = {
  content: string;
  className?: string;
};

/** 본문 스타일은 globals.css 의 .ck-editor-body 에 있다 */
export default function CkEditorContent({ content, className }: Props) {
  const enhancedContent = enhanceEmbeddedContentHtml(content);

  return (
    <div
      className={`border-b border-solid border-apps-coreProductDivider max-h-full py-10 ${
        className ? `ck-content ${className}` : 'ck-content'
      }`}
    >
      <div
        className="ck-editor-body"
        dangerouslySetInnerHTML={{ __html: enhancedContent }}
      />
    </div>
  );
}
